import React, { useState } from 'react';
import { Play } from 'lucide-react';
import { useScrollReveal } from '../hooks/useScrollReveal';

const VIDEO_ID = '1kpzG9PmdzI';

const VideoShowcase = () => {
  const [sectionRef, isSectionVisible] = useScrollReveal();
  const [playing, setPlaying] = useState(false);

  return (
    <section className="py-20 lg:py-28 bg-gray-50">
      <div
        ref={sectionRef}
        className={`section-container reveal ${isSectionVisible ? 'visible' : ''}`}
      >
        <div className="text-center mb-12">
          <span
            className="inline-block text-sm font-semibold text-[#00BCE4] uppercase tracking-[3px] mb-4"
            style={{ fontFamily: 'Outfit, sans-serif' }}
          >
            Customer Success Story
          </span>
          <h2
            className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 leading-tight"
            style={{ fontFamily: 'Outfit, sans-serif' }}
          >
            Simply Cartons &<br className="md:hidden" /> <span className="text-[#00BCE4]">Imprint-MIS</span>
          </h2>
          <p
            className="text-base md:text-lg text-gray-600 mt-4 max-w-3xl mx-auto"
            style={{ fontFamily: 'Inter, sans-serif' }}
          >
            Discover how Simply Cartons transformed their carton manufacturing workflow with a tailored Imprint MIS installation
          </p>
        </div>

        {/* Video Container */}
        <div className="max-w-5xl mx-auto">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl border-4 border-white group">
            <div
              style={{
                position: 'relative',
                paddingBottom: '56.25%',
                height: 0,
                overflow: 'hidden',
              }}
            >
              {playing ? (
                <iframe
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                  }}
                  src={`https://www.youtube.com/embed/${VIDEO_ID}?autoplay=1`}
                  title="Simply Cartons & Imprint-MIS Success Story"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              ) : (
                <button
                  type="button"
                  onClick={() => setPlaying(true)}
                  data-testid="video-facade-play"
                  aria-label="Play video: Simply Cartons & Imprint-MIS Success Story"
                  className="absolute inset-0 w-full h-full cursor-pointer"
                >
                  <img
                    src={`https://i.ytimg.com/vi/${VIDEO_ID}/hqdefault.jpg`}
                    alt="Simply Cartons & Imprint-MIS Success Story video preview"
                    loading="lazy"
                    className="w-full h-full object-cover"
                  />
                  <span className="absolute inset-0 bg-black/25 group-hover:bg-black/10 transition-colors duration-300" />
                  <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex items-center justify-center w-20 h-20 rounded-full bg-[#00BCE4] shadow-2xl group-hover:scale-110 transition-transform duration-300">
                    <Play size={32} className="text-white ml-1" fill="currentColor" />
                  </span>
                </button>
              )}
            </div>
          </div>

          {/* Video Description */}
          <div className="mt-8 text-center">
            <p
              className="text-sm text-gray-500 italic"
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              See how our bespoke MIS solution helped Simply Cartons achieve a 30% reduction in estimating time and significant improvements in on-time delivery
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VideoShowcase;
